const Card = ({ label, value, hint, accent, testId }) => (
  <div className="rounded-md border border-[#222D3D] bg-[#141A24] p-5 fade-up" data-testid={testId}>
    <p className="text-[11px] font-semibold tracking-[0.18em] uppercase text-slate-500">{label}</p>
    <p className={`mt-3 text-3xl font-mono font-bold ${accent || "text-slate-50"}`}>{value}</p>
    {hint && <p className="mt-1 text-xs text-slate-500">{hint}</p>}
  </div>
);

export const StatsRow = ({ stats }) => {
  const s = stats || {};
  const top = s.top?.[0];
  return (
    <div className="grid grid-cols-2 lg:grid-cols-5 gap-4">
      <Card testId="metric-card-total-visits" label="Arrivals logged" value={s.total ?? "—"} hint={`${s.auto ?? 0} detected · ${s.manual ?? 0} by hand`} />
      <Card testId="metric-card-verified" label="Origin verified" value={s.verified ?? "—"} hint={`${s.unverifiable ?? 0} can't be checked`} accent="text-emerald-400" />
      <Card testId="metric-card-flagged" label="Flagged" value={(s.impersonators ?? 0) + (s.undeclared ?? 0)} hint={`${s.impersonators ?? 0} impersonators · ${s.undeclared ?? 0} undeclared`} accent={(s.impersonators || s.undeclared) ? "text-rose-400" : "text-slate-50"} />
      <Card testId="metric-card-top-agent" label="Most frequent" value={top ? top.identity : "—"} hint={top ? `${top.count} arrivals` : "No arrivals yet"} accent="text-cyan-400 text-xl sm:text-2xl truncate" />
      <Card testId="metric-card-anchor-count" label="Bitcoin anchors" value={s.anchors ?? "—"} hint={`${s.unanchored ?? 0} entries waiting · ${s.confirmed_anchors ?? 0} confirmed`} accent="text-[#F7931A]" />
    </div>
  );
};
